import { render, staticRenderFns } from "./ConsultantCommissionList.vue?vue&type=template&id=f4928604"
import script from "./ConsultantCommissionList.vue?vue&type=script&lang=js"
export * from "./ConsultantCommissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4928604')) {
      api.createRecord('f4928604', component.options)
    } else {
      api.reload('f4928604', component.options)
    }
    module.hot.accept("./ConsultantCommissionList.vue?vue&type=template&id=f4928604", function () {
      api.rerender('f4928604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/ConsultantCommissionList.vue"
export default component.exports